/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CreateFile {
  readonly id: string;
  readonly file: string;
  readonly description: string;
  readonly content_type: string;
  readonly object_id: string;
}
